import { a as d } from "./chunk-BaseElement-BuXbltG-.js";
import { r as s } from "./chunk-recentlyViewedStorage-ClRKUesv.js";
import { t as i } from "./chunk-custom-element-ttkHUa8w.js";
import { n as f } from "./chunk-property-Baio2yOX.js";
var m = Object.defineProperty, u = Object.getOwnPropertyDescriptor, n = (l, t, o, r) => {
  for (var e = r > 1 ? void 0 : r ? u(t, o) : t, a = l.length - 1, c; a >= 0; a--)
    (c = l[a]) && (e = (r ? c(t, o, e) : c(e)) || e);
  return r && e && m(t, o, e), e;
};
let p = class extends d {
  connectedCallback() {
    super.connectedCallback(), this.productHandle && s.add(this.productHandle);
  }
};
n([
  f({ type: String, attribute: "product-handle" })
], p.prototype, "productHandle", 2);
p = n([
  i("track-recently-viewed")
], p);
export {
  p as TrackRecentlyViewed
};
